import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'


export const pagetableColumnLinkProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  tail: [Boolean, String],
})

export type PagetableColumnLinkProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnLinkProps>>>

export default defineComponent({
  name: 'OPagetableColumnLink',
  inheritAttrs: false,
  props: pagetableColumnLinkProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
